import useApps from "@app/common/hooks/useApps";
import type { SSOProviderId } from "@app/common/types/providerTypes";
import openAppBrowser from "@app/embedded/zoom/utils/openAppBrowser";

import { getOauthUrl } from "./ssoUtils";

const useAddAccountProvider = () => {
  const { client } = useApps();
  const addAccountProvider = (
    providerId: SSOProviderId,
    options?: {
      returnPath?: string;
      errorReturnPath?: string;
      queryParams?: URLSearchParams | { [key: string]: string };
      forceConsent?: boolean;
    }
  ) => {
    const url = `${getOauthUrl(providerId, options)}&action=add_sso`;
    if (client === "zoom") {
      openAppBrowser(url);
      return;
    }
    window.location.href = url;
  };

  return { addAccountProvider };
};

export default useAddAccountProvider;
